import type {
  MatchingUnreadCountParams,
  NotificationData,
  NotificationFilterOptionsParams,
  NotificationFilters,
  NotificationSettingEntry,
} from "../types";

export const notificationQueryKeys = {
  all: ["notifications"] as const,
  pages: () => [...notificationQueryKeys.all, "page"] as const,
  page: (filters: NotificationFilters) => [...notificationQueryKeys.pages(), filters] as const,
  details: () => [...notificationQueryKeys.all, "detail"] as const,
  detail: (notificationId: NotificationData["id"] | null) =>
    [...notificationQueryKeys.details(), notificationId] as const,
  unreadCount: () => [...notificationQueryKeys.all, "unreadCount"] as const,
  matchingUnreadCount: (params: MatchingUnreadCountParams | null) =>
    [...notificationQueryKeys.unreadCount(), params] as const,
  filters: () => [...notificationQueryKeys.all, "filters"] as const,
  filter: (params: NotificationFilterOptionsParams) => [...notificationQueryKeys.filters(), params] as const,
};

export const notificationSettingQueryKeys = {
  all: ["notification-settings"] as const,
  list: () => [...notificationSettingQueryKeys.all, "list"] as const,
  updates: () => [...notificationSettingQueryKeys.all, "update"] as const,
  update: (id: NotificationSettingEntry["id"]) => [...notificationSettingQueryKeys.updates(), id] as const,
};
